import type { SVGProps } from 'react';
const SvgSubdirectoryArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#subdirectory_arrow_right_svg__a)">
      <path
        fill="currentColor"
        d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6Z"
      />
    </g>
    <defs>
      <clipPath id="subdirectory_arrow_right_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSubdirectoryArrowRight;
